import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { StudySearchStrategyDatabase } from '../../../models/studySearchStrategyDatabase.model';
import _ from 'lodash-es';
import { DatabaseType, CharacterType, ComponentType } from '../../_study_constants';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { Subject } from 'rxjs';
import { OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { selectSearchStrategyDatabases } from '../../analysis/search-strategy/state/study-search-strategy.selectors';
import { KeywordFilterService } from '@services/keyword-filter.service';

@Component({
  selector: 'app-filter-keywords',
  templateUrl: './filter-keywords.component.html',
  styleUrls: ['./filter-keywords.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  encapsulation: ViewEncapsulation.None,
})
export class FilterKeywordsComponent implements OnInit, OnDestroy {
  @Input() filter: any;
  @Input() readOnly = false;

  searchStrategyDatabases: StudySearchStrategyDatabase[];
  formDirty = false;
  isOptionSelected?: boolean = null;
  isNonBvdSelected = false;

  destroy$ = new Subject();
  connectorCount = 0;

  constructor(private store: Store<AppState>, private keywordFilterService: KeywordFilterService) {}

  ngOnInit(): void {
    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectSearchStrategyDatabases))
      .subscribe((databases) => {
        this.searchStrategyDatabases = databases;
      });

    this.setOptionSelected();

    this.isNonBvdSelected = _.some(this.searchStrategyDatabases, function (item: StudySearchStrategyDatabase) {
      return (
        item.databaseId === DatabaseType.OneSource || item.databaseId === DatabaseType.CompustatNA || item.databaseId === DatabaseType.CompustatGlobal
      );
    });
    if (this.isNonBvdSelected) {
      this.filter.fullOverview = true;
      this.filter.tradeDescription = false;
      this.filter.nativeLanguage = false;

      this.onSelection();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  onSelection() {
    this.formDirty = true;
    this.setOptionSelected();
  }

  setOptionSelected() {
    this.isOptionSelected = !this.filter.fullOverview && !this.filter.tradeDescription && !this.filter.nativeLanguage ? null : true;
  }

  keywordChanged($event): void {
    this.getConnectorCount($event);
  }

  getConnectorCount(booleanLogic: string): boolean {
    this.connectorCount = 0;
    let prevComponentType: ComponentType = null;
    let prevConnector: string = null;

    if (this.keywordFilterService.findEnterRegex.test(booleanLogic)) {
      return false;
    }

    let input: string = _.toLower(_.trim(booleanLogic));

    if (input === '*' || input === '"*"') {
      return true;
    }

    while (input.length > 0) {
      const character = input.slice(0, 1);
      input = input.substr(1);

      const charType = this.keywordFilterService.determineCharacterType(character);

      if (charType === CharacterType.OpeningBracket) {
        prevComponentType = ComponentType.OpeningBracket;
      } else if (charType === CharacterType.ClosingBracket) {
        prevComponentType = ComponentType.ClosingBracket;
      }

      if (charType === CharacterType.Quote) {
        const phrase = this.keywordFilterService.getPhrase(input);

        input = input.substr(phrase.length + 1);
        prevComponentType = ComponentType.Phrase;
      } else if (charType === CharacterType.Character) {
        const text = character + this.keywordFilterService.getWord(input);
        const isConnector = this.keywordFilterService.allowedConnectors.includes(text) ? true : false;

        if (isConnector) {
          if (this.keywordFilterService.processConnector(text, prevConnector, prevComponentType)) {
            const isAndNotConnector =
              text === this.keywordFilterService.notConnector && prevConnector !== null && prevConnector === this.keywordFilterService.andConnector;
            if (!isAndNotConnector && input.substr(text.length - 1).length > 0) {
              this.connectorCount = this.connectorCount + 1;
            }
          }
          prevConnector = text;
        }
        prevComponentType = isConnector ? ComponentType.Connector : ComponentType.Word;
        input = input.substr(text.length - 1); // - 1 because the first char was already consumed
      }
    }

    return true;
  }
}
